<template>
  <el-dialog class="center-dialog" :title="`资格证书(${changeTypes.length}/30)`" :visible="value" @update:visible="handleVisibleChange" width="700" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-scrollbar style="height: 500px;">
      <div class="dialog-body">
        <div class="select_header type-list">
          已选择：<div class="type-item" v-for="(item,index) in changeTypes" :key="item">{{ item }} <i style="margin-left: 5px;cursor: pointer;" @click="deltetSelect(index)" class="el-icon-close"></i></div>
        </div>
        <div class="body-filter">
          <el-input v-model="keyword" placeholder="请输入" size="small">
            <template slot="prefix">
              <i class="el-icon-search"></i>
            </template>
          </el-input>
        </div>

        <div class="change-box">
          <div class="change-box_left">
            <div :class="['list-item', { active: item.name === current }]" v-for="item in list" :key="item.name" @click="current = item.name">
              <span>{{ item.name }}</span>

              <i class="el-icon-arrow-right"></i>
            </div>
          </div>

          <div class="change-box_right">
            <template v-if="currentTab.length > 0">
              <div class="tab-item">
                <div class="type-list">
                  <div :class="['type-item', { active: changeTypes.includes(type.name) }]" v-for="type in currentNoSublist" :key="type.name" @click="handleChangeType(type.name)">
                    {{ type.name }}
                  </div>
                </div>
              </div>
              <div class="tab-item" v-for="item in currentTab" :key="item.name">
                <div class="tab-item_label" v-if="item.subList.length!==0">{{ item.name }}</div>
                <div class="type-list" v-if="item.subList.length!==0">
                  <div :class="['type-item', { active: changeTypes.includes(type.name) }]" v-for="type in item.subList" :key="type.name" @click="handleChangeType(type.name)">
                    {{ type.name }}
                  </div>
                </div>
              </div>
            </template>

            <template v-else>
              <div class="right-empty" style="display: flex; align-items: center; justify-content: center; padding-top: 180px">暂无数据</div>
            </template>
          </div>
        </div>
      </div>
    </el-scrollbar>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleConfirm" style="background: #594fed">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import zigezhengshu from "@/utils/zigezhengshu.json";
export default {
  name: "ChangeTypeDialog",
  data() {
    return {
      keyword: "",
      current: "推荐证书",
      changeTypes: [],
      list: zigezhengshu,
    };
  },

  model: {
    prop: "value",
    event: "input",
  },

  props: {
    value: {
      type: Boolean,
      required: true,
    },
    certificateList: {
      type: Array,
      default: () => [],
    },
  },

  watch: {
    value(val) {
      if (val) {
        this.changeTypes = [...this.certificateList];
      }
    },
  },

  computed: {
    currentTab() {
      const findTab = this.list.find((item) => item.name === this.current);
      return findTab?.subList || [];
    },
    currentNoSublist() {
      let arr = this.currentTab.filter((item) => {
        if (item.subList.length == 0) {
          return item;
        }
      });
      console.log(arr);

      return arr || [];
    },
  },
  mounted() {
    this.sortedTabs();
  },

  methods: {
    deltetSelect(index) {
      this.changeTypes.splice(index, 1);
    },
    sortedTabs() {
      // 复制原数组避免修改源数据
      this.list.forEach((item) => {
        item.subList = [...item.subList].sort((a, b) => {
          // subList为空的项（length=0）排在前面，不为空的排在后面
          if (a.subList.length === 0 && b.subList.length !== 0) return -1;
          if (a.subList.length !== 0 && b.subList.length === 0) return 1;
          // 同类型的项保持原顺序
          return 0;
        });
      });
    },
    handleVisibleChange(val) {
      this.$emit("input", val);
    },

    handleChangeType(type) {
      const typeIndex = this.changeTypes.findIndex((item) => item === type);

      if (typeIndex !== -1) {
        this.changeTypes.splice(typeIndex, 1);
      } else {
        if (this.changeTypes.length >= 30) {
          this.$message.warning("所选证书已达上限");
        } else {
          this.changeTypes.push(type);
        }
      }
    },

    handleConfirm() {
      if (this.changeTypes.length === 0) {
        this.$message.warning("请选择需求类型");
        return;
      }

      this.$emit("change", this.changeTypes);
      this.handleVisibleChange(false);
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-body {
  .select_header {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 10px;
    .type-item {
      font-weight: 400;
      font-size: 12px;
      color: #333333;
      line-height: 30px;
      padding: 1px 8px;
      border-radius: 2px;
      border: 1px solid #ebebeb;
      background: #eeedfd;
      border-color: #756deb;
      color: #594fed;
      border-radius: 2px;
    }
  }
  .body-filter {
    border-radius: 4px 4px 0 0;
    border: 1px solid #e1e3e5;

    ::v-deep(.el-input__prefix) {
      display: flex;
      align-items: center;
      font-size: 20px;
    }

    ::v-deep(.el-input__inner) {
      border: none;
    }
  }

  .change-box {
    height: 450px;
    border: 1px solid #e1e3e5;
    border-top: none;
    border-radius: 0 0 4px 4px;
    display: flex;

    &_left {
      border-right: 1px solid #e1e3e5;
      width: 144px;
      height: 100%;
      overflow-y: scroll;

      &::-webkit-scrollbar {
        display: none;
      }

      .list-item {
        --color: #333333;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-inline: 20px;
        margin-top: 10px;
        cursor: pointer;
        color: var(--color);

        &.active {
          background-color: #eeedfd;
          --color: #594fed;
        }
      }
    }

    &_right {
      flex: 1;
      height: 100%;
      overflow-y: scroll;
      padding: 16px;
      box-sizing: border-box;

      &::-webkit-scrollbar {
        display: none;
      }

      .tab-item {
        & + .tab-item {
          margin-top: 30px;
        }

        &_label {
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 14px;
          color: #000000;
          line-height: 30px;
        }

        .type-list {
          margin-top: 10px;
          display: flex;
          flex-wrap: wrap;
          gap: 16px;

          .type-item {
            font-weight: 400;
            font-size: 12px;
            color: #333333;
            line-height: 30px;
            padding: 1px 8px;
            background: #ffffff;
            border-radius: 2px;
            border: 1px solid #ebebeb;
            cursor: pointer;

            &.active {
              background: #eeedfd;
              border-color: #756deb;
              color: #594fed;
            }
          }
        }
      }
    }
  }
}
</style>
